var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcSaveStroke = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M3 6a5 5 0 0 1 5-5h8a5 5 0 0 1 5 5v13.054c0 2.023-2.348 3.138-3.916 1.861l-4.727-3.85a.3.3 0 0 0-.374-.004l-5.11 3.972C5.296 22.26 3 21.135 3 19.138zm5-3a3 3 0 0 0-3 3v13.138a.4.4 0 0 0 .646.316l5.11-3.972a2.3 2.3 0 0 1 2.864.032l4.727 3.85a.4.4 0 0 0 .653-.31V6a3 3 0 0 0-3-3z",
  clipRule: "evenodd"
})));
export default SvgIcSaveStroke;